import $ from 'jquery';

const initSlick = () => {
	$('.wp-block-emagine-logo-gallery.is-slider').slick();
};

window.addEventListener('DOMContentLoaded', initSlick);
